//REDUCER
import { RECEIVE_COURSE, RESET_COURSE } from '../actions'


import { createAction, createReducer } from '@reduxjs/toolkit'

const initialCourseState = {
    metadata: {},
    topics: [],
    translations: [],
    outline: [],
    us_states: []
};


const course = createReducer(initialCourseState, (builder) => {
    builder
      .addCase(createAction(RECEIVE_COURSE), (state, action) => {
        state.metadata = action.json.course.data;
        state.topics = action.json.topic_meta_ids;
        state.translations = action.json.translations;
        state.outline = action.json.outline;
        state.us_states = action.json.us_states;
      })
      .addCase(createAction(RESET_COURSE), () => initialCourseState)
  })


export default course